const PAYMENT_KEYS = [
  'payment_type',
  'is_subscription',
  'payment_method',
  'new_user',
];

const PUBLIC_MARKETING_PATHS = new Set(['/faq', '/help', '/privacy', '/terms']);

export function parseSsoParams(search = '') {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const token = params.get('token') || '';
  const referer = params.get('referer') || '';
  const returnPath = sanitizeReturnPath(params.get('return_path'));
  const context = {
    referer,
    returnPath,
    org: params.get('org') || '',
  };

  PAYMENT_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value !== null && value !== '') context[key] = value;
  });

  return { token, context };
}

export function sanitizeReturnPath(path) {
  if (!path) return '/courses';
  const trimmed = String(path).trim();
  if (!trimmed.startsWith('/')) return '/courses';
  if (trimmed.startsWith('//')) return '/courses';
  try {
    const url = new URL(trimmed, 'https://step.local');
    if (url.origin !== 'https://step.local') return '/courses';
    if (PUBLIC_MARKETING_PATHS.has(url.pathname)) return '/courses';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/courses';
  }
}

export function persistSsoContext(context = {}) {
  if (typeof localStorage === 'undefined') return;
  if (context.payment_type) localStorage.setItem('payment_type', context.payment_type);
  if (context.is_subscription) localStorage.setItem('is_subscription', context.is_subscription);
  if (context.payment_method) localStorage.setItem('payment_method', context.payment_method);
  if (context.new_user) localStorage.setItem('new_user', context.new_user);
  if (context.referer) localStorage.setItem('referer', context.referer);

  if (context.referer === 'landing') {
    localStorage.setItem('TriggerBuyNow', 'Yes');
    localStorage.setItem('paymentInProcess', '1');
  }
}
